import { render, staticRenderFns } from "./AppointmentConfigModal.vue?vue&type=template&id=ec1f4e5c&scoped=true&"
import script from "./AppointmentConfigModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentConfigModal.vue?vue&type=style&index=0&id=ec1f4e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1f4e5c",
  null
  
)

export default component.exports